/**
 * De 5-minuten-antwoordklok (18-10-2026, Jordy): fase, rest en een kleine
 * gedeelde opslag voor de globale teller.
 *
 * Fase (resterende tijd van de 5-minutenwindow): > 3:00 groen, 1:00–3:00 oranje,
 * < 1:00 rood. Alleen gesprekken in stand "replied" (de fan antwoordde, de klok
 * loopt) tellen; "waiting" (wacht op de fan) blijft rustig.
 *
 * Geen React in de pure functies (getest met node).
 */
export type KlokFase = 'groen' | 'oranje' | 'rood'

export function restSeconden(tot: unknown, nu = Date.now()): number {
  const t = new Date(String(tot ?? '')).getTime()
  return Number.isFinite(t) ? Math.max(0, Math.ceil((t - nu) / 1000)) : 0
}

export function klokFase(sec: number): KlokFase {
  return sec > 180 ? 'groen' : sec >= 60 ? 'oranje' : 'rood'
}

export interface KlokRij {
  id: number
  inbox_claim_mine?: boolean | null
  inbox_claim_active?: boolean | null
  inbox_claim_state?: string | null
  inbox_claim_until?: string | null
  fan_display_name?: string | null
  fan_username?: string | null
}

/** Mijn aftellende gesprekken, meest urgent eerst. */
export function mijnKlokken(rijen: KlokRij[] | undefined, nu = Date.now()): KlokRij[] {
  return (rijen ?? [])
    .filter((r) => r.inbox_claim_mine && r.inbox_claim_active && r.inbox_claim_state === 'replied'
      && restSeconden(r.inbox_claim_until, nu) > 0)
    .sort((a, b) => restSeconden(a.inbox_claim_until, nu) - restSeconden(b.inbox_claim_until, nu))
}

// ── een kleine opslag: de wachtrij (Layout) schrijft, de teller leest ──────
let huidig: KlokRij[] = []
const luisteraars = new Set<() => void>()

export function zetKlokRijen(rijen: KlokRij[] | undefined): void {
  huidig = rijen ?? []
  luisteraars.forEach((f) => f())
}

export function abonneer(f: () => void): () => void {
  luisteraars.add(f)
  return () => { luisteraars.delete(f) }
}

export const klokRijen = (): KlokRij[] => huidig
